module.exports = __webpack_public_path__ + "media/img/akquinet-logo-0e2d6ac95225307ced30b7fb23ee1a4e.svg";